import { Outlet } from 'react-router-dom';
import Navbar from '../components/navigation/Navbar';
import Footer from '../components/navigation/Footer';
import Screensaver from '../components/base/Screensaver';
import Taskbar from '../components/navigation/Taskbar';

/**
 * RootLayout - Main layout wrapper for all routes
 *
 * @component
 * @description Wraps all pages with persistent Navbar and main content area
 *
 * @structure
 * - Navbar (fixed at top, always visible)
 * - Main content area (Outlet renders child routes)
 * - Padding top to account for fixed navbar
 */
const RootLayout = () => {
  return (
    <>
      {/* Persistent Navbar */}
      <Navbar />

      {/* Main Content Area */}
      <main style={{ paddingTop: 'var(--nav-height)' }}>
        <Outlet />
      </main>

      <Footer />

      {/* XP taskbar — Start menu, Winamp tray icon, clock */}
      <Taskbar />

      {/* Idle Easter egg — bouncing logo after a stretch of inactivity */}
      <Screensaver />
    </>
  );
};

export default RootLayout;
